import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Skeleton } from 'components/UnvUI'

import $api from 'http/index'

import styles from './CareerPage.module.scss'

const fmtDate = (iso) => {
  if (!iso) return '—'
  try {
    return new Date(iso).toLocaleDateString('ru-RU')
  } catch {
    return '—'
  }
}

const CareerPage = () => {
  const { t } = useTranslation('common')
  const [tab, setTab] = useState('vacancies')
  const [vacancies, setVacancies] = useState([])
  const [graduates, setGraduates] = useState([])
  const [loadingV, setLoadingV] = useState(true)
  const [loadingG, setLoadingG] = useState(true)
  const [errorV, setErrorV] = useState(false)
  const [errorG, setErrorG] = useState(false)

  useEffect(() => {
    const loadV = async () => {
      setLoadingV(true)
      setErrorV(false)
      try {
        const res = await $api.get('/career/vacancies/')
        setVacancies(res.data?.results || res.data || [])
      } catch {
        setErrorV(true)
        setVacancies([])
      } finally {
        setLoadingV(false)
      }
    }
    const loadG = async () => {
      setLoadingG(true)
      setErrorG(false)
      try {
        const res = await $api.get('/career/graduates/')
        setGraduates(res.data?.results || res.data || [])
      } catch {
        setErrorG(true)
        setGraduates([])
      } finally {
        setLoadingG(false)
      }
    }
    loadV()
    loadG()
  }, [])

  return (
    <div className={styles.page}>
      <div className={`unv-card ${styles.header}`}>
        <h1 className={styles.title}>{t('career.title_page')}</h1>
      </div>

      <div className={`unv-card ${styles.tabsWrap}`}>
        <div className={styles.tabs}>
          <button
            className={`unv-btn ${tab === 'vacancies' ? '' : 'unv-btn--ghost'}`}
            onClick={() => setTab('vacancies')}
          >
            {t('career.tab_vacancies')}
          </button>
          <button
            className={`unv-btn ${tab === 'graduates' ? '' : 'unv-btn--ghost'}`}
            onClick={() => setTab('graduates')}
          >
            {t('career.tab_graduates')}
          </button>
        </div>
      </div>

      <div className={`unv-card ${styles.content}`}>
        {tab === 'vacancies' && (
          <>
            {loadingV ? (
              <div className={styles.loaderWrap}>
                <Skeleton variant="table" rows={5} cols={4} />
              </div>
            ) : errorV ? (
              <div className="unv-empty">{t('career.section_in_dev')}</div>
            ) : vacancies.length === 0 ? (
              <div className="unv-empty">{t('career.no_vacancies')}</div>
            ) : (
              <table className="unv-table">
                <thead>
                  <tr>
                    <th>{t('career.col_company')}</th>
                    <th>{t('career.col_position')}</th>
                    <th>{t('career.col_deadline')}</th>
                    <th>{t('career.col_link')}</th>
                  </tr>
                </thead>
                <tbody>
                  {vacancies.map((v) => (
                    <tr key={v.id}>
                      <td>{v.company || '—'}</td>
                      <td>{v.position || '—'}</td>
                      <td>{fmtDate(v.deadline)}</td>
                      <td>
                        {v.link ? (
                          <a href={v.link} target="_blank" rel="noreferrer">
                            {t('career.go_link')}
                          </a>
                        ) : (
                          '—'
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </>
        )}

        {tab === 'graduates' && (
          <>
            {loadingG ? (
              <div className={styles.loaderWrap}>
                <Skeleton variant="table" rows={5} cols={4} />
              </div>
            ) : errorG ? (
              <div className="unv-empty">{t('career.section_in_dev')}</div>
            ) : graduates.length === 0 ? (
              <div className="unv-empty">{t('career.no_graduates')}</div>
            ) : (
              <table className="unv-table">
                <thead>
                  <tr>
                    <th>{t('career.col_full_name')}</th>
                    <th>{t('career.col_grad_year')}</th>
                    <th>{t('career.col_specialty')}</th>
                    <th>{t('career.col_current_company')}</th>
                    <th>{t('career.col_position')}</th>
                  </tr>
                </thead>
                <tbody>
                  {graduates.map((g) => (
                    <tr key={g.id}>
                      <td>{g.full_name || '—'}</td>
                      <td>{g.graduation_year || '—'}</td>
                      <td>{g.specialty || '—'}</td>
                      <td>{g.company || '—'}</td>
                      <td>{g.position || '—'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default CareerPage
